import axiosClient from './axiosClient';

const authApi = {
  // POST /api/login -> { token, user }
  login: (data) => axiosClient.post('/login', data),

  // POST /api/register -> { token, user } (registro de cliente)
  register: (data) => axiosClient.post('/register', data),

  // POST /api/logout (invalida el token actual en el backend)
  logout: () => axiosClient.post('/logout'),

  // GET /api/user -> usuario autenticado actual (segun el token enviado)
  me: () => axiosClient.get('/user'),

  // PUT /api/profile -> actualiza nombre/telefono del propio usuario autenticado
  updateProfile: (data) => axiosClient.put('/profile', data),

  // PUT /api/profile/password -> cambia la contrasena del propio usuario autenticado
  updatePassword: (data) => axiosClient.put('/profile/password', data),

  // POST /api/forgot-password -> envia correo de recuperacion
  forgotPassword: (email) => axiosClient.post('/forgot-password', { email }),

  // POST /api/reset-password -> restablece la contrasena con token de correo
  resetPassword: (data) => axiosClient.post('/reset-password', data),
};

export default authApi;
